import {Injectable} from "@angular/core";
import {environment} from "../../../environments/environment";
import {map, Observable} from "rxjs";
import {HttpClient} from "@angular/common/http";
import {AddToWaitingListCommand} from "homey-housing-lottery-app-dto";

@Injectable({
  providedIn: 'root'
})
export class WaitingListRegistrationService {

    constructor(private readonly http: HttpClient) { }

    public addToWaitingList(email: string): Observable<void> {
      const command: AddToWaitingListCommand = {
        email: email
      }
      return this.http.post(`${environment.apiUrl}/api/public/waiting-list-registrations`, command).pipe(
        map(() => {})
      )
    }
}
